import { useEffect, useState } from "react";
import moment from 'moment';
import 'moment/locale/es';
import { useParams } from "react-router-dom";
import axios from 'axios';
import './Pages.css';
import { Helmet } from 'react-helmet';
import logo from '../../assets/images/logo_radioital_blanco.png';
import SocialShare from "./SocialShare";

function getDia(num) {
  let meses = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado" ];
  return meses[num];
}

const Pages = () => {
  const id = useParams();
  const API_URL = 'https://radioital.com/api/public/api/programas/show/' + id.id;
  const AUDIO_URL = 'https://radioital.com/api/public/api/programas/audios/' + id.id;
  const [data, setData] = useState(null);
  const [horarios, setHorarios] = useState(null);
  const [audios, setAudios] = useState(null);

  useEffect(() => {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    //datos del programa
    axios.get(API_URL, {
      headers: {
        //'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer token' // si lo usas
      }
    })
      .then(function(res){
        setData(res.data.data);
        setHorarios(res.data.schedule);
      });

    axios.get(AUDIO_URL, {
      headers: {
        //'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer token' // si lo usas
      }
    })
      .then((res) => setAudios(res.data.mp3s));
  }, []);

  if (data) {
    return (<>
      <Helmet>
        <title>{data.ttlo_prgrm} Radioshow</title>
        <meta property="og:title" content={data.ttlo_prgrm} />
        <meta property="og:description" content={data.dscrpcn_prgrm} />
        <meta property="og:image" content="https://radioital.com/static/media/logo.png" />
        <meta property="og:url" content={"https://radioital.com/radioshow"+data.key_prgrm} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={data.ttlo_prgrm} />
        <meta name="twitter:description" content={data.dscrpcn_prgrm} />
        <meta name="twitter:image" content="https://radioital.com/static/media/logo.png" />
      </Helmet>
      <div className="post">
        <div className="post_body">
          <div className="post_body_left">
            <img src={"../shows/" + data.imgn_prgrm} alt={data.ttlo_prgrm} className="show-image2" />
            <h1>{data.ttlo_prgrm}</h1>
            <h3>Conduce: {data.rspnsbl_prgrm}</h3>
          </div>
          <div className="post_body_right">
            <p>{data.dscrpcn_prgrm}</p>
            <span className="schedule_post">CONECTATE CON SUS TRANSMISIONES</span>
            <table className="table2">
              <thead>
                <tr>
                  <th colSpan={2}>EN VIVO</th>
                  <th colSpan={2}>REPETICIÓN</th>
                </tr>
              </thead>
              <tbody>
                {horarios?.map((item, indexl) => (
                  item.tpprgrm_hrrio === "1" &&
                    <tr key={indexl} className='country-item2'>
                        <td colSpan={2}>
                           <h3>{getDia(item.dia_hrrio)}</h3>
                          <div className='flags2'>
                            <div key={indexl} className='flag-item2'>
                                <img alt='img' src="/flag_col.png"  />
                                <div className='time'>
                                    <p>{moment(item.hini_hrrio, "hh:mm").format('hh:mm A')} - {moment(item.hfin_hrrio, "hh:mm").format('hh:mm A')}</p>
                                </div>
                            </div>
                          </div>
                        </td>
                        {horarios?.map((item, indexl) => (
                          item.tpprgrm_hrrio === "2" &&
                            <td key={indexl} colSpan={2}>
                              <h3>{getDia(item.dia_hrrio)}</h3>
                              <div className='flags2'>
                                <div key={indexl} className='flag-item2'>
                                    <img alt='img' src="/flag_col.png"  />
                                    <div className='time'>
                                        <p>{moment(item.hini_hrrio, "hh:mm").format('hh:mm A')} - {moment(item.hfin_hrrio, "hh:mm").format('hh:mm A')}</p>
                                    </div>
                                </div>
                              </div>
                            </td>
                        ))}
                    </tr> 
                ))}
                {horarios?.map((item, indexl) => (
                  horarios.length === 1 && item.tpprgrm_hrrio === "2" &&
                  <tr key={indexl} className='country-item2'>
                    <td key={indexl} colSpan={2}></td>
                    <td key={indexl} colSpan={2}>
                      <h3>{getDia(item.dia_hrrio)}</h3>
                      <div className='flags2'>
                        <div key={indexl} className='flag-item2'>
                            <img alt='img' src="/flag_col.png"  />
                            <div className='time'>
                                <p>{moment(item.hini_hrrio, "hh:mm").format('hh:mm A')} - {moment(item.hfin_hrrio, "hh:mm").format('hh:mm A')}</p>
                            </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="socialshare">
          <SocialShare
              title={data.ttlo_prgrm}
              url={"https://radioital.com/radioshow/"+data.key_prgrm}
            />
        </div>
      </div>
      {audios ?
        <div className="audios_show">
          <h2>PROGRAMAS ANTERIORES</h2>
          <ul>
          {audios.map((item, indexa) => (
              <li key={indexa}>
                <div className='div_audios'>
                  <span className="h1_titulos">{item.nombre}</span>
                  <audio controls controlsList="nodownload" preload="none">
                    <source src={item.url} type="audio/mpeg" />
                    Tu navegador no soporta audio.
                  </audio>
                </div>
              </li>
          ))}
          </ul>
        </div>
      : 
      <div className="audios_show">
        <h2>
          Estamos cargando sus programas anteriores...
        </h2>
      </div>
      }
      </>
    )
  }else{
    <div className="post">
        <div className="post_body">
          <h2>Estamos cargando su contenido...</h2>
        </div>
    </div>
  }
};

export default Pages;